import { defaultTo } from 'lodash';
import { DateTime } from 'luxon';
import { IModel, Model, ModelRecord } from './Model';

export interface IClinicTaskFollowupListingModel extends IModel {
  clinicTaskFollowupId: number;
  clinicTaskId: number;
  dateCreated: string;
  userFirstName: string;
  userLastName: string;
  userTitle: string;
  comment: string;
}

export class ClinicTaskFollowupListingModel
  extends Model
  implements ModelRecord<IClinicTaskFollowupListingModel>
{
  clinicTaskFollowupId: number;
  clinicTaskId: number;
  dateCreated: DateTime;
  userFirstName: string;
  userLastName: string;
  userTitle: string;
  comment: string;

  constructor(params: Partial<IClinicTaskFollowupListingModel>) {
    super(params);
    this.clinicTaskFollowupId = defaultTo(params.clinicTaskFollowupId, 0);
    this.clinicTaskId = defaultTo(params.clinicTaskId, 0);
    this.dateCreated = DateTime.fromISO(
      defaultTo(params.dateCreated, '2000-01-01'),
      { zone: 'utc' },
    );
    this.userFirstName = defaultTo(params.userFirstName, '');
    this.userLastName = defaultTo(params.userLastName, '');
    this.userTitle = defaultTo(params.userTitle, '');
    this.comment = defaultTo(params.comment, '');
  }
}
